export default "__VITE_ASSET__CwXOFRdg__"